export default __webpack_public_path__ + "static/media/appIcon-100.84618c69.png";